module.exports = __webpack_public_path__ + "static/media/Medal.0c46cb6a.png";